import React from 'react'

import { tx } from '@twind/core'

type ContentBannerProps = {
  className?: string
  wrapperClassName?: string
  src: string
}

export const ContentBanner = ({
  className,
  wrapperClassName,
  src
}: ContentBannerProps) => {
  return (
    <div className={tx(wrapperClassName)}>
      <img
        src={src}
        alt="project banner"
        className={tx(
          'object-cover object-center max-h-[400px] w-full rounded-t-md',
          className
        )}
      />
    </div>
  )
}
